import { Pencil } from 'lucide-react';
import React from 'react';
import { AnimatedCircularProgressBar } from '@/Components/shadcn/animated-circular-progress-bar';
import { Button } from '@/Components/shadcn/button';
import UIStrings from '@/Utils/UIStrings';
import { ExperienceCriterionFinalScore } from '@/Models/ExperienceCriterionFinalScore';
import AdjustedByRecruiterChip from './AdjustedByRecruiterChip';

interface CriteriaRowProps {
    criterionFinalScore: ExperienceCriterionFinalScore;
    index: number;
    onEdit: (criterionScoreToEdit: ExperienceCriterionFinalScore) => void;
}

const CriteriaRow = ({ criterionFinalScore, index, onEdit }: CriteriaRowProps) => {
    const { criterionScore, criterion, justification } = criterionFinalScore;

    return (
        <div className="text-foreground flex flex-row items-start gap-5 px-5 py-10">
            <AnimatedCircularProgressBar
                value={criterionScore?.score}
                level={criterionScore?.scoreLevel}
                className="size-12 text-base font-semibold"
            />
            <div className="flex min-w-0 flex-1 flex-col gap-2.5">
                <div className="flex flex-row items-start justify-between gap-2">
                    <div className="min-w-0 flex-1">
                        <h4 className="text-xl font-semibold">{`${UIStrings.Criteria(index + 1)}:`}</h4>
                        <h5 className="text-base font-semibold">{criterion}</h5>
                    </div>
                    <Button
                        type="button"
                        variant="default-outline"
                        size="xs"
                        onClick={() => onEdit(criterionFinalScore)}
                    >
                        <Pencil />
                        {UIStrings.Edit}
                    </Button>
                </div>
                <div>
                    <p className="text-base font-bold">{UIStrings.Justification}:</p>
                    <p className="text-base whitespace-pre-line">{justification}</p>
                </div>
                {criterionFinalScore.isUserDefinedScore && (
                    <div className="flex flex-row justify-end">
                        <AdjustedByRecruiterChip />
                    </div>
                )}
            </div>
        </div>
    );
};

export default CriteriaRow;
